module.exports = __webpack_public_path__ + "static/media/12.3f63f333.png";